<template>
  <div>
    <div class="test-processing-section w-100">
      <div class="container h-100">
        <div class="row position-relative h-100">
          <div
            class="col-12 d-flex flex-column justify-content-center align-items-center position-absolute h-100"
          >
            <!-- SPINNER -->
            <div class="avatar">
              <span
                class="icon-dotted-spinner flex-center border_grey animate"
              ></span>
            </div>
            <!-- SPINNER -->
            <!-- PROCESSING TEXT -->
            <p class="text color_white text-center mt-4">
              {{ loader_text }} ....
            </p>
            <!-- PROCESSING TEXT -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionLoader",

  props: {
    loader_text: String,
  },
};
</script>

<style lang="scss">
@keyframes blinker {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.test-processing-section {
  z-index: 999;
  @include fixed_full_section;
  background: rgba($brand_primary, 0.9);
  transition: all 0.4s ease-in-out;

  .row {
    .col-12 {
      @include transform_center;
      .avatar {
        @include equal_min_edge(55);

        @include breakpoint_max(sm) {
          @include equal_min_edge(45);
        }
      }
      span {
        font-size: 50px;
        @include breakpoint_max(sm) {
          font-size: 35px;
        }
      }
    }
  }

  .text {
    font-size: 17px;
    line-height: 29px;

    @include breakpoint_max(sm) {
      font-size: 14px;
    }
  }

  .ellipsis-blinker {
    transition: all 0.4s ease-in-out;
    animation: blinker 1.5s linear infinite;
  }
}
</style>
